import { spacing } from "globalStyles";
import React, { ChangeEvent, InputHTMLAttributes, ReactNode } from "react";
import styled from "styled-components";
import Body from "ui/Text/Body";
import InputContainer from "./components/Container";
import InputHelperText from "./components/HelperText";
import { InputColor, InputProps } from "./interfaces";

interface Props extends InputProps, InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: ReactNode;
  color?: InputColor;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const InputCheckbox: React.FC<Props> = ({
  checked = false,
  name,
  label,
  onChange,
  color = "primary",
  hasError = false,
  errorMessage = "",
  helperText = "",
  className,
  ...other
}) => {
  return (
    <InputContainer className={className}>
      <Container>
        <>
          <Input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            name={name}
            {...other}
          />
          {React.isValidElement(label) ? (
            React.cloneElement(label, { className: "ml-sm" })
          ) : (
            <Label inputColor={color} variant="body6">
              {label}
            </Label>
          )}
        </>
      </Container>
      <InputHelperText
        hasError={hasError}
        errorMessage={errorMessage}
        helperText={helperText}
        color={color}
      />
    </InputContainer>
  );
};

export default InputCheckbox;

const Input = styled.input`
  margin: 0;
  width: 15px;
  height: 15px;
`;

const Container = styled.label`
  display: flex;
  align-items: center;
`;

const Label = styled(Body)<{ inputColor: InputColor }>`
  color: ${({ theme, inputColor }) => theme.colors.input[inputColor].content};
  margin-left: ${spacing.small}px;
`;
